import { Component, OnInit, Input } from '@angular/core';
import { Router, ActivatedRoute, Params } from '@angular/router';

// APP
import { EntityService } from '../../services/entity.service';
import { SharedService } from '../../services/shared.service';

@Component({
    selector: 'app-topmenu',
    templateUrl: './topmenu.component.html',
    providers: [EntityService]
})
export class TopmenuComponent implements OnInit {
    projectDetail: any;
    projectId: number= 0;
    topMenu: number;
    pageError: Array<any> = [];
    isInDraft: boolean = false; 
    userName: string = '';
    userEmail: string = ''; 
    userPhone: string = ''; 
    @Input('isAppEditable') isAppEditable: boolean = false;

    constructor(private router: Router
        , private entityService: EntityService
        , private sharedService: SharedService) { }

    ngOnInit() {
        
        var url = this.router.url;
        if (url != null) {
            url = url.toUpperCase();
            if (url.indexOf('APPLICATION') > -1)
                this.topMenu = 1;
            else if (url.indexOf('UPLOADS') > -1)
                this.topMenu = 2;
            else if (url.indexOf('SIGNOFF') > -1)
                this.topMenu = 3;
            else if (url.indexOf('FEECOLLECTION') > -1)
                this.topMenu = 4;
            else if (url.indexOf('PERMITNOTICE') > -1)
                this.topMenu = 5;
        }

        let ids = this.sharedService.getJsonData("id");
        if (ids != null) {
            if (ids.projectId != null) {
                this.projectId = ids.projectId;

                if (ids.appStatus == 'Draft')
                    this.isInDraft = true; 
            }
        }   

        this.entityService.getProjectDetailById(this.projectId)
            .subscribe(
            successResp => this.projectDetail = successResp.Result,
            errorResp => this.pageError.push(' Get ProjectDetail: ' + errorResp.statusText));

        var user = this.sharedService.getJsonData("loggedInUser");
        this.userName = user.FirstName; 
        this.userEmail = user.UserID;
        var account = this.sharedService.getJsonData('account'); 
        if (!(account == null || account.phone == null)) {
            this.userPhone = account.phone;             
        }

        
    }
}